/** INFO
 * 해당 모달은 반복 예약을 삭제할 때 사용하는 모달입니다.
 * - 모달에서는 "이 일정" | "이 일정 및 향후 일정" | "모든 일정" 중 하나를 선택할 수 있습니다.
 * - `삭제하기` 버튼을 클릭하면, 모달에서 선택한 옵션에 따라 반복 예약을 삭제합니다.
 * - 삭제가 완료되면, 모달을 닫고, onDelete 콜백을 호출합니다.
 */

export type RepeatReservationDeleteModalProps = {
  modalIsOpen: boolean;
  closeModal: () => void;
  onDelete: (option: RepeatReservationDeleteOption) => void;
};

export enum RepeatReservationDeleteOption {
  THIS_SCHEDULE = "THIS_SCHEDULE",
  THIS_SCHEDULE_AND_FUTURE_SCHEDULES = "THIS_SCHEDULE_AND_FUTURE_SCHEDULES",
  ALL_SCHEDULES = "ALL_SCHEDULES",
}
